module.exports = __webpack_public_path__ + "static/media/WoodPanelType2.bc6583ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WoodPanelType2.png
// module id = 1190
// module chunks = 0